import styled from 'styled-components';
import { media, when } from 'utils';
import { IconLoading } from 'components/common/icons';
import SelectMenu from 'components/common/select-menu';

export const Wrapper = styled.div`
  padding-top: 3rem;

  ${media.mobile`
    padding-top: 0;
  `}
`;

export const MainContent = styled.div`
  padding: 0 4rem;

  ${media.desktopL`
    padding-top: 3rem;
  `}

  ${media.tablet`
    padding-top: 4.5rem;
  `}

  ${media.mobile`
    padding: 0 2rem;
  `}
`;

export const DashboardHeader = styled.div`
  position: relative;
  display: flex;
  align-content: center;
  justify-content: center;
  margin: 2.5rem 0;

  & svg:first-child {
    width: 15.8rem;
    height: 3.2rem;
  }

  & > *:last-child {
    position: absolute;
    right: -1rem;
  }

  & svg:last-child {
    color: #787878;
  }
`;

export const SideContent = styled.div`
  position: relative;
  background-image: url('${process.env.NODE_ENV === 'production'
    ? '/_next-assets/'
    : '/static/'}images/wave-pattern.svg');
  flex: 0 0 32rem;

  ${media.tablet`
    width: 100%;
    order: 3;
  `}
`;

export const LogoClasses = styled.div`
  display: inline-block;
  font-family: Monoline, 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-size: 2.8rem;

  ::after {
    content: 'Mindbodygreen';
    color: #222;
    ${({ isTranslucent, fontColor }) => isTranslucent && `color: ${fontColor || '#fff'};`}
  }

  ${media.desktopL`
    margin-bottom: 1rem;
  `}

  ${media.tablet`
    margin-bottom: 2rem;
  `}

  ${media.mobile`
    display: none;
  `}
`;

export const Loader = styled(IconLoading)`
  position: fixed;
  top: 45%;
  margin: auto;
  left: 0;
  right: 0;
`;

export const LoadError = styled.div`
  padding: 10rem 2rem;
  text-align: center;
  font-size: 1.6rem;

  & p {
    margin-bottom: 2rem;
  }
`;

export const Button = styled.button`
  background: ${(props) => props.theme.colors.classesTeal};
  color: ${(props) => props.theme.colors.standard.text.inverted};
  text-transform: uppercase;
  margin: 0 auto;
  display: block;

  border-radius: 3rem;
  font-weight: bold;
  font-size: 1.3rem;
  letter-spacing: 0.2rem;
  padding: 1.5rem 5rem;
  cursor: pointer;
`;
